export function navigationValidationRules(
    workspaceLocalStorage: string,
    organizationLocalStorage: string,
    nameOrg: string
) {
  return `/${organizationLocalStorage}/${workspaceLocalStorage}/validationRule`;
}